import { PrimarySecondaryPage } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { useIntl } from "react-intl";
import { OnboardingStepper } from "onboarding";

import { BankStatementUpload, BankStatementUploadSecondaryContent } from "../../../components";

export const AirBankStatementsPage = ({
  customerDomain,
  air,
  onBack,
}: {
  customerDomain: string;
  air: FundingApplicationSchemas.AIRSchema;
  onBack: () => void;
}) => {
  const intl = useIntl();
  const titleSlot = air.is_subsequent_funding ? undefined : <OnboardingStepper currentStep={5} />;

  return (
    air.air_data && (
      <PrimarySecondaryPage
        titleSlot={titleSlot}
        showStepperBackground={!!titleSlot}
        title={intl.formatMessage({
          id: "funding-application: air bank statement required title",
          defaultMessage: "Upload your bank statements",
        })}
        primaryContent={
          <BankStatementUpload
            airPublicId={air.air_data.public_identifier}
            bankData={air.air_data.data as FundingApplicationSchemas.BankStatementsForAccountAIRSchema}
            customerDomain={customerDomain}
            onBack={onBack}
          />
        }
        secondaryContent={<BankStatementUploadSecondaryContent />}
      />
    )
  );
};
